export default "__VITE_ASSET__DY_04Iso__"